import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { NgClass, NgIf } from '@angular/common';
import { RxButtonModule } from '../button/button.module';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'rx-modal-content',
  styleUrls: ['./modal-content.component.scss'],
  templateUrl: './modal-content.component.html',
  standalone: true,
  imports: [NgClass, NgIf, RxButtonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalContentComponent {
  @Input() headerCentered = false;
  @Input() showCloseButton = true;
  @Output() closeModal = new EventEmitter<string>();
}
